import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CredentialsService} from '@app/auth/credentials.service';

function isLegacy(url: string) {
    return url.includes('devapi.golfdigg.com') || url.includes('api.golfdigg.com') || url.includes(':8080/golfdigg');
}

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private credentialsService: CredentialsService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const token = this.credentialsService.token;
        if (token) {
            const headers: { [key: string]: string } = {};
            if (request.url.includes('ngrok')) {
                request = request.clone({
                    setHeaders: {
                        'ngrok-skip-browser-warning': 'true',
                    }
                });
            }
            if (isLegacy(request.url)) {
                request = request.clone({
                    setHeaders: {
                        // mamo: token,
                        Authorization: `Bearer ${token}`
                    }
                });
            } else {
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
            }
        }

        return next.handle(request);
    }
}
